import { render, staticRenderFns } from "./EditClientModal.vue?vue&type=template&id=21217232&scoped=true"
import script from "./EditClientModal.vue?vue&type=script&lang=js"
export * from "./EditClientModal.vue?vue&type=script&lang=js"
import style0 from "./EditClientModal.vue?vue&type=style&index=0&id=21217232&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21217232",
  null
  
)

export default component.exports